import React, { useEffect, useState } from "react";
import "./PaymentSuccess.css";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { useDispatch } from "react-redux";
import { postOrder } from "../../features/admin/product/productdetails/Slice";
import WhiteButton from "../common_components/common_button/WhiteButton";

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [orderDetails, setOrderDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [paymentData, setPaymentData] = useState({});

  const orderData = JSON.parse(Cookies.get("orderData") || "{}");

  useEffect(() => {
    createOrder();
  }, []);

  //   const createOrder = async () => {
  //     try {
  //       const res = await dispatch(postOrder(orderData));

  //       if (postOrder.fulfilled.match(res)) {
  //         Cookies.remove("orderData");

  //         // Save response for display
  //         setPaymentData({
  //           txnId:
  //             res.payload?.data?.txnID ||
  //             res.payload?.data?.transaction_id ||
  //             "-",
  //           amount: orderData?.grand_total,
  //         });
  //       }

  //       if (postOrder.rejected.match(res)) {
  //         setError(res?.payload?.message || "Unable to create order.");
  //       }
  //     } catch (err) {
  //       setError("Something went wrong.");
  //     } finally {
  //       setLoading(false);
  //     }
  //   };
  const createOrder = async () => {
    try {
      const res = await dispatch(postOrder(orderData));

      if (postOrder.fulfilled.match(res)) {
        setOrderDetails(res.payload.data);
        Cookies.remove("orderData");
      }

      if (postOrder.rejected.match(res)) {
        setError(res?.payload?.message || "Unable to create order.");
      }
    } catch (err) {
      setError("Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="payment-status">
      <div className="payment-status-card">
        <div className="success-icon">✓</div>

        <h1>Payment Successful</h1>

        {loading ? (
          <p>Creating your order...</p>
        ) : error ? (
          <p className="payment-error">{error}</p>
        ) : (
          <>
            <p>Thank you! Your payment has been processed successfully.</p>

            <div className="payment-details">
              <div className="payment-row">
                <span>Order Number</span>
                <strong>{orderDetails?.order_number}</strong>
              </div>

              <div className="payment-row">
                <span>Invoice No</span>
                <strong>{orderDetails?.invoice_no}</strong>
              </div>

              <div className="payment-row">
                <span>Order ID</span>
                <strong>{orderDetails?.id}</strong>
              </div>

              <div className="payment-row">
                <span>Customer</span>
                <strong>{orderDetails?.name}</strong>
              </div>

              <div className="payment-row">
                <span>Email</span>
                <strong>{orderDetails?.email}</strong>
              </div>

              <div className="payment-row">
                <span>Amount</span>
                <strong>₹ {orderDetails?.grand_total}</strong>
              </div>

              <div className="payment-row">
                <span>Subtotal</span>
                <strong>₹ {orderDetails?.sub_total}</strong>
              </div>

              <div className="payment-row">
                <span>Shipping</span>
                <strong>₹ {orderDetails?.shipping_charges}</strong>
              </div>

              <div className="payment-row">
                <span>Status</span>
                <strong className="success-text">
                  {orderDetails?.order_status?.name}
                </strong>
              </div>

              <div className="payment-row">
                <span>Payment Method</span>
                <strong>ICICI Payment Gateway</strong>
              </div>

              <div className="payment-row">
                <span>Address</span>
                <strong>{orderDetails?.address}</strong>
              </div>

              <div className="payment-row">
                <span>City</span>
                <strong>{orderDetails?.city}</strong>
              </div>

              <div className="payment-row">
                <span>Date</span>
                <strong>
                  {new Date(orderDetails?.created_at).toLocaleString()}
                </strong>
              </div>
            </div>

            <WhiteButton
              title="Continue"
              bg="#000"
              color="#f35f37"
              hoverBg="#000"
              hoverColor="#f35f37"
              onClick={() => navigate("/order-placed")}
            />

            <div className="payment-footer">
              A confirmation has been sent to your registered email/mobile.
            </div>
          </>
        )}
      </div>
    </section>
  );
};

export default PaymentSuccess;
